import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { mediaPath, openWatchState } from '../utils/mediaRoute';
import PlaylistSave from './playlistSave';
import logo from '../img/n89.png';
import '../styles/compsStyles/shorts-section.css';

const ShortCard = ({ item, onClick }) => (
  <article className="shortCard" onClick={onClick}>
    <div className="shortCard__media">
      <img
        src={`/api/uploads/${item.thumbnail}`}
        alt={item.title}
        className="shortCard__thumb"
      />
      <div className="shortCard__overlay" />
    </div>
    <div className="shortCard__meta">
      <p className="shortCard__title">{item.title}</p>
      <PlaylistSave
        className="shortCard__more"
        icon={<BsThreeDotsVertical />}
        post={{
          id: item.id,
          title: item.title,
          thumbnail: item.thumbnail,
          type: item.type || 's',
          image: item.image || item.thumbnail || ''
        }}
      />
    </div>
  </article>
);

const ShortsSection = ({ list = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const shorts = Array.isArray(list) ? list : []

  if (!shorts.length) return null;

  return (
    <section className="shortsSection">
      <div className="shortsSection__header">
        <img src={logo} alt="" className="shortsSection__logo" />
        <h2 className="shortsSection__title">Shorts</h2>
      </div>
      <div className="shortsSection__row">
        {shorts.map((item, idx) => (
          <ShortCard
            key={`${item.id}-${idx}`}
            item={item}
            onClick={() => navigate(mediaPath(item), { state: openWatchState(item, location) })}
          />
        ))}
      </div>
    </section>
  );
};

export default ShortsSection;
